import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { MenuType, Loading } from "../../../../../../../utils/helpers/constants";
import PageLayout from "../../../../../../../components/layouts/PageLayout";
import { getTripByOrderSetReference } from "../../../../../../../store/actions/booking.action";
import { getUserJourneyDates } from "../../../../../../../utils/helpers/logicHelper";
import moment from "moment";
import MapHook from "../../../../../../../components/hooks/MapHook";

const TrackOrderset = () => {
    const dispatch = useDispatch(), { ref } = useParams();

    const tripInfo = useSelector((state) => state.bookingsReducer.orderSetTripInfo);
    const loadingTrackTrip = useSelector((state) => state.bookingsReducer.loadingOrderSetTripInfo === Loading.FETCHING);

    useEffect(() => {
        if (ref) dispatch(getTripByOrderSetReference(ref));
    }, [dispatch, ref]);


    const timeline = (tripInfo && Array.isArray(tripInfo.user_journey))
    ? getUserJourneyDates(tripInfo)
    : null;

    return (
        <PageLayout menu={MenuType.WHA} isLoading={loadingTrackTrip}>
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Track Delivery</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to="/">Home</NavLink></li>
                        <li className="breadcrumb-item">
                            <NavLink to="/services/warehouse-automation/deliveries">Deliveries</NavLink>
                        </li>
                        <li className="breadcrumb-item active"
                            aria-current="page">{tripInfo.destination && tripInfo.destination[0] ? tripInfo.destination[0]['orderset'] : ""}</li>
                    </ol>
                </div>
            </div>

            {tripInfo?.destination?.[0]?.picks?.[0]?.pickup &&
                <div className="d-flex flex-column flex-md-row justify-content-between">
                    <div className=" mb-3 me-md-3 card custom-card w-100 p-4 main-contact-info-body">
                        <div className="media">
                            <div className="media-body">
                                <div>
                                    <label aria-label="biz-assigned">Outlet</label>
                                    <span className="tx-medium">
                                        {(tripInfo && tripInfo.destination && tripInfo.destination[0]['merchant']['extras']['name']) ? tripInfo.destination[0]['merchant']['extras']['name'] : ''}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="media">
                            <div className="media-body">
                                <div>
                                    <label aria-label="biz-assigned-country">Outlet Address</label>
                                    <span className="tx-medium">
                                        {(tripInfo && tripInfo.destination && tripInfo.destination[0]['merchant']['address']['name'])
                                            ? tripInfo.destination[0]['merchant']['address']['name'] : "-"}
                                        {" "}
                                        {tripInfo && tripInfo.destination ?
                                            (tripInfo.destination[0]['merchant']['address']['address'] ? tripInfo.destination[0]['merchant']['address']['address']
                                                : (tripInfo.destination[0]['merchant']['address']['city'] && tripInfo.destination[0]['merchant']['address']['state'])
                                                    ? `${tripInfo.destination[0]['merchant']['address']['city']} ${tripInfo.destination[0]['merchant']['address']['state']}` : "-")
                                            : "-"
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="media">
                            <div className="media-body">
                                <div>
                                    <label aria-label="biz-assigned">Delivery Type</label>
                                    <span className="tx-medium">{tripInfo['trip_type'] ? tripInfo['trip_type'] : '-'}</span>
                                </div>
                            </div>
                        </div>
                        <div className="media">
                            <div className="media-body">
                                <div>
                                    <label aria-label="biz-assigned">Delivery Reference</label>
                                    <span className="tx-medium">{tripInfo['reference'] ? tripInfo['reference'] : '-'}</span>
                                </div>
                            </div>
                        </div>

                        <h5 className="main-content-label text-muted mt-5 mb-2">Merchant</h5>
                        <div className="media">
                            <div className="media-body">
                                <div>
                                    <label>Merchant's Email</label>
                                    {(tripInfo && tripInfo.destination && tripInfo && tripInfo.destination && tripInfo.destination[0]['merchant']['email']) ?
                                        <a href={`mailto:${tripInfo.destination[0]['merchant']['email']}`} className="tx-medium pointer-event">
                                            {tripInfo.destination[0]['merchant']['email']}
                                        </a> : "-"
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="media">
                            <div className="media-body">
                                <div>
                                    <label>Merchant's Phone</label>
                                    {(tripInfo && tripInfo.destination && tripInfo && tripInfo.destination && tripInfo.destination[0]['merchant']['phone']) ?
                                        <a href={`tel:${tripInfo && tripInfo.destination && tripInfo.destination[0]['merchant']["phone"]}`} className="tx-medium pointer-event">
                                            {tripInfo.destination[0]['merchant']["phone"]}
                                        </a> : "-"
                                    }
                                </div>
                            </div>
                        </div>

                        {/* <h5 className="main-content-label text-muted mt-5 mb-2">Warehouse Administrative</h5>
                    <div className="media">
                        <div className="media-body">
                            <div>
                                <label>Administrative Name</label>
                                <span className="tx-medium">
                                    {(tripInfo["administrative"] && tripInfo["administrative"]["created_by"]) ? tripInfo["administrative"]["created_by"] : "-"}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="media">
                        <div className="media-body">
                            <div>
                                <label>Administrative Email</label>
                                {(tripInfo["administrative"] && tripInfo["administrative"]["created_by_email"]) ?
                                    <a href={`mailto:${tripInfo["administrative"]["created_by_email"]}`}
                                        className="tx-medium pointer-event">
                                        {tripInfo["administrative"]["created_by_email"]}
                                    </a> : "-"
                                }
                            </div>
                        </div>
                    </div> */}

                    </div>

                    <div className="ms-md-3 mb-3  card custom-card w-100 p-4">
                        <div className="d-flex gap-lg-2 column-gap-3 justify-content-between">
                            <div>
                                <p className="text-13px text-slightdark">Delivery Start Date</p>
                                <p className="tx-medium text-darker">
                                    {timeline && timeline["INITIATED"] ? moment(timeline["INITIATED"]).format("llll") : "-"}
                                </p>
                            </div>
                            {/* <Line
								percent={lineProgressStatus()}
								strokeWidth={4}
								trailWidth={4}
								strokeColor="#FFAB00"
								trailColor="#D3D3D3"
								className="line mt-2 me-2"
							/> */}
                            <div>
                                <p className="text-13px text-slightdark">
                                    {timeline && timeline["COMPLETED"] ? "Delivery End Date" : "Expected Delivery Date"}
                                </p>
                                <p className="tx-medium text-darker">
                                    {timeline ? timeline["COMPLETED"] ? moment(timeline["COMPLETED"]).format("llll")
                                        : moment(tripInfo?.scheduled_date).format("llll") : "--"}
                                </p>
                            </div>
                        </div>
                        <div className="border-bottom my-4" />
                        <h6 className="text-darker">Latest Updates</h6>

                        <div className="row mt-4">
                            {(tripInfo && tripInfo.user_journey) && tripInfo.user_journey.map((item, index) => (
                                <div key={index} className="col-6 mb-30px">
                                    <p className="text-13px text-slightdark">{moment(item.time).format("llll")}</p>
                                    <p className="tx-medium text-darker">{item.message}</p>
                                </div>
                            ))}
                        </div>
                    </div>


                </div>
            }

            <div className="card custom-card">
                {(tripInfo && tripInfo.source && tripInfo.destination[0]) && 
                <div className="map" style={{ height: "400px", width: "100%" }}>
                    <MapHook source={tripInfo?.source} destination={tripInfo?.destination[0].address} />
                </div>}
            </div>
        </PageLayout>
    )

}

export default TrackOrderset